import {
  DEFAULT_ACCOUNTANT_SEAWEED_ACCESS_TABS,
  SEAWEED_ACCOUNTANT_TAB_PATHS,
} from '../constants/seaweedAccessTabs';

const PORTAL_CONFIG = {
  seaweed: {
    baseUrl: process.env.REACT_APP_SEAWEEDS_UI_URL,
    pathPrefix: '',
    label: 'Seaweeds',
  },
};

export function isBusinessOpen(business) {
  const portalAccess = business?.portal_access ?? business?.portal_state ?? 'open';
  return business?.status === 'active' && portalAccess === 'open';
}

export function isLaunchableBusiness(business) {
  return Boolean(getPortalConfig(business)) && isBusinessOpen(business);
}

export function findLaunchableBusinessForUser(businesses, user) {
  const launchableBusinesses = businesses.filter((business) => isLaunchableBusiness(business));

  if (!launchableBusinesses.length) {
    return null;
  }

  const primaryBusinessId = Number(user?.customer_id);

  return (
    launchableBusinesses.find((business) => Number(business.id) === primaryBusinessId) ||
    launchableBusinesses[0]
  );
}

export function buildBusinessPortalUrl({
  business,
  portalRole,
  token,
  hideBackAction = false,
  seaweedAccessTabs = null,
}) {
  const portalConfig = getPortalConfig(business);

  if (!portalConfig) {
    return '';
  }

  const rolePath = portalRole === 'staff' ? 'staff' : 'admin';
  const launchPath =
    portalRole === 'accountant'
      ? getAccountantSeaweedEntryPath(seaweedAccessTabs, token)
      : `/${rolePath}/dashboard`;
  const portalRoleParam = portalRole || rolePath;
  const baseUrl = portalConfig.baseUrl.replace(/\/$/, '');
  const params = new URLSearchParams({
    businessId: String(business.id),
    portalRole: portalRoleParam,
    returnUrl: getPortalReturnUrl(portalRole === 'accountant' ? 'staff' : rolePath),
  });

  if (token) {
    params.set('portalToken', token);
  }

  if (hideBackAction) {
    params.set('hideBackAction', '1');
  }

  const paramSeparator = launchPath.includes('?') ? '&' : '?';

  return `${baseUrl}${portalConfig.pathPrefix}${launchPath}${paramSeparator}${params.toString()}`;
}

function getAccountantSeaweedEntryPath(seaweedAccessTabs, token) {
  const accessTabs = Array.isArray(seaweedAccessTabs)
    ? seaweedAccessTabs
    : readSeaweedAccessTabsFromToken(token) || DEFAULT_ACCOUNTANT_SEAWEED_ACCESS_TABS;
  const allowedTabIds = new Set(accessTabs);
  const firstAllowedTab = SEAWEED_ACCOUNTANT_TAB_PATHS.find(([tabId]) => allowedTabIds.has(tabId));

  return firstAllowedTab?.[1] || '/admin/releasing';
}

function readSeaweedAccessTabsFromToken(token) {
  if (!token) {
    return null;
  }

  try {
    const [, encodedPayload] = token.split('.');
    const base64Payload = encodedPayload.replace(/-/g, '+').replace(/_/g, '/');
    const normalizedPayload = base64Payload.padEnd(
      base64Payload.length + ((4 - (base64Payload.length % 4)) % 4),
      '='
    );
    const payload = JSON.parse(window.atob(normalizedPayload));

    return Array.isArray(payload.seaweed_access_tabs) ? payload.seaweed_access_tabs : null;
  } catch (error) {
    return null;
  }
}

function getPortalReturnUrl(rolePath) {
  if (rolePath === 'staff') {
    return `${window.location.origin}/login`;
  }

  return `${window.location.origin}/${rolePath}`;
}

export function getPortalLabel(business) {
  return getPortalConfig(business)?.label || 'business';
}

function getPortalConfig(business) {
  const systemType = String(business?.system_type || '').trim().toLowerCase();
  return PORTAL_CONFIG[systemType] || null;
}
